// Mock data for UsersDemo component - Extracted for better performance

export const mockUsers = [
  {
    id: 1,
    name: 'John',
    lastName: 'Doe',
    email: 'john.doe@example.com',
    phone: '+1 (555) 123-4567',
    role: 'Owner',
    status: 'Active',
    expirationDate: 'Dec 31, 2024',
    estate: 'The Beach - Unit 101',
    estateGroup: 'The Beach',
    estateGroupId: 1,
  },
  {
    id: 2,
    name: 'Jane',
    lastName: 'Smith',
    email: 'jane.smith@example.com',
    phone: '+1 (555) 234-5678',
    role: 'Resident',
    status: 'Pending',
    expirationDate: 'Nov 15, 2024',
    estate: 'The Beach - Unit 102',
    estateGroup: 'The Beach',
    estateGroupId: 1,
  },
  {
    id: 3,
    name: 'Mike',
    lastName: 'Johnson',
    email: 'mike.johnson@example.com',
    phone: '+1 (555) 345-6789',
    role: 'Guest',
    status: 'Inactive',
    expirationDate: 'Oct 30, 2024',
    estate: 'The Beach - Unit 103',
    estateGroup: 'The Beach',
    estateGroupId: 1,
  },
  {
    id: 4,
    name: 'Sarah',
    lastName: 'Wilson',
    email: 'sarah.wilson@example.com',
    phone: '+1 (555) 456-7890',
    role: 'Owner',
    status: 'Active',
    expirationDate: 'Jan 15, 2025',
    estate: 'The Beach - Unit 201',
    estateGroup: 'The Beach',
    estateGroupId: 1,
  },
  {
    id: 5,
    name: 'David',
    lastName: 'Brown',
    email: 'david.brown@example.com',
    phone: '+1 (555) 567-8901',
    role: 'Resident',
    status: 'Expired',
    expirationDate: 'Sep 20, 2024',
    estate: 'The Beach - Unit 202',
    estateGroup: 'The Beach',
    estateGroupId: 1,
  },
  // Additional mock users for pagination testing (total 28)
  { id: 6, name: 'Alice', lastName: 'Green', email: 'alice.green@example.com', phone: '+1 (555) 678-9012', role: 'Resident', status: 'Active', expirationDate: 'Jan 10, 2025', estate: 'The Beach - Unit 203', estateGroup: 'The Beach', estateGroupId: 1 },
  { id: 7, name: 'Bob', lastName: 'White', email: 'bob.white@example.com', phone: '+1 (555) 789-0123', role: 'Guest', status: 'Pending', expirationDate: 'Dec 10, 2024', estate: 'The Beach - Unit 204', estateGroup: 'The Beach', estateGroupId: 1 },
  { id: 8, name: 'Carol', lastName: 'Black', email: 'carol.black@example.com', phone: '+1 (555) 890-1234', role: 'Owner', status: 'Inactive', expirationDate: 'Nov 05, 2024', estate: 'The Beach - Unit 205', estateGroup: 'The Beach', estateGroupId: 1 },
  { id: 9, name: 'Derek', lastName: 'Young', email: 'derek.young@example.com', phone: '+1 (555) 901-2345', role: 'Resident', status: 'Active', expirationDate: 'Jan 20, 2025', estate: 'The Beach - Unit 206', estateGroup: 'The Beach', estateGroupId: 1 },
  { id: 10, name: 'Eva', lastName: 'King', email: 'eva.king@example.com', phone: '+1 (555) 012-3456', role: 'Guest', status: 'Expired', expirationDate: 'Oct 10, 2024', estate: 'The Beach - Unit 207', estateGroup: 'The Beach', estateGroupId: 1 },
  { id: 11, name: 'Frank', lastName: 'Hill', email: 'frank.hill@example.com', phone: '+1 (555) 222-3333', role: 'Owner', status: 'Active', expirationDate: 'Feb 14, 2025', estate: 'The Beach - Unit 208', estateGroup: 'The Beach', estateGroupId: 1 },
  { id: 12, name: 'Grace', lastName: 'Baker', email: 'grace.baker@example.com', phone: '+1 (555) 333-4444', role: 'Resident', status: 'Pending', expirationDate: 'Dec 01, 2024', estate: 'The Beach - Unit 209', estateGroup: 'The Beach', estateGroupId: 1 },
  { id: 13, name: 'Henry', lastName: 'Carter', email: 'henry.carter@example.com', phone: '+1 (555) 444-5555', role: 'Guest', status: 'Inactive', expirationDate: 'Sep 28, 2024', estate: 'The Beach - Unit 210', estateGroup: 'The Beach', estateGroupId: 1 },
  { id: 14, name: 'Ivy', lastName: 'Diaz', email: 'ivy.diaz@example.com', phone: '+1 (555) 555-6666', role: 'Resident', status: 'Active', expirationDate: 'Jan 30, 2025', estate: 'The Beach - Unit 211', estateGroup: 'The Beach', estateGroupId: 1 },
  { id: 15, name: 'Jack', lastName: 'Edwards', email: 'jack.edwards@example.com', phone: '+1 (555) 666-7777', role: 'Owner', status: 'Active', expirationDate: 'Mar 05, 2025', estate: 'The Beach - Unit 212', estateGroup: 'The Beach', estateGroupId: 1 },
  { id: 16, name: 'Kate', lastName: 'Foster', email: 'kate.foster@example.com', phone: '+1 (555) 777-8888', role: 'Resident', status: 'Pending', expirationDate: 'Nov 21, 2024', estate: 'The Beach - Unit 213', estateGroup: 'The Beach', estateGroupId: 1 },
  { id: 17, name: 'Leo', lastName: 'Gonzalez', email: 'leo.gonzalez@example.com', phone: '+1 (555) 888-9999', role: 'Guest', status: 'Active', expirationDate: 'Dec 31, 2024', estate: 'The Beach - Unit 214', estateGroup: 'The Beach', estateGroupId: 1 },
  { id: 18, name: 'Mia', lastName: 'Hughes', email: 'mia.hughes@example.com', phone: '+1 (555) 999-0000', role: 'Resident', status: 'Inactive', expirationDate: 'Sep 15, 2024', estate: 'The Beach - Unit 215', estateGroup: 'The Beach', estateGroupId: 1 },
  { id: 19, name: 'Nate', lastName: 'Irwin', email: 'nate.irwin@example.com', phone: '+1 (555) 101-2020', role: 'Owner', status: 'Active', expirationDate: 'Apr 18, 2025', estate: 'The Beach - Unit 216', estateGroup: 'The Beach', estateGroupId: 1 },
  { id: 20, name: 'Olivia', lastName: 'Johnson', email: 'olivia.johnson@example.com', phone: '+1 (555) 202-3030', role: 'Resident', status: 'Expired', expirationDate: 'Oct 12, 2024', estate: 'The Beach - Unit 217', estateGroup: 'The Beach', estateGroupId: 1 },
  { id: 21, name: 'Paul', lastName: 'Kim', email: 'paul.kim@example.com', phone: '+1 (555) 303-4040', role: 'Guest', status: 'Pending', expirationDate: 'Nov 08, 2024', estate: 'The Beach - Unit 218', estateGroup: 'The Beach', estateGroupId: 1 },
  { id: 22, name: 'Quinn', lastName: 'Lopez', email: 'quinn.lopez@example.com', phone: '+1 (555) 404-5050', role: 'Resident', status: 'Active', expirationDate: 'Feb 12, 2025', estate: 'The Beach - Unit 219', estateGroup: 'The Beach', estateGroupId: 1 },
  { id: 23, name: 'Rose', lastName: 'Mason', email: 'rose.mason@example.com', phone: '+1 (555) 505-6060', role: 'Owner', status: 'Inactive', expirationDate: 'Sep 01, 2024', estate: 'The Beach - Unit 220', estateGroup: 'The Beach', estateGroupId: 1 },
  { id: 24, name: 'Sam', lastName: 'Nguyen', email: 'sam.nguyen@example.com', phone: '+1 (555) 606-7070', role: 'Resident', status: 'Active', expirationDate: 'Jan 12, 2025', estate: 'The Beach - Unit 221', estateGroup: 'The Beach', estateGroupId: 1 },
  { id: 25, name: 'Tina', lastName: 'Owens', email: 'tina.owens@example.com', phone: '+1 (555) 707-8080', role: 'Guest', status: 'Expired', expirationDate: 'Oct 18, 2024', estate: 'The Beach - Unit 222', estateGroup: 'The Beach', estateGroupId: 1 },
  { id: 26, name: 'Uma', lastName: 'Perez', email: 'uma.perez@example.com', phone: '+1 (555) 808-9090', role: 'Resident', status: 'Pending', expirationDate: 'Dec 22, 2024', estate: 'The Beach - Unit 223', estateGroup: 'The Beach', estateGroupId: 1 },
  { id: 27, name: 'Victor', lastName: 'Quinn', email: 'victor.quinn@example.com', phone: '+1 (555) 909-0001', role: 'Owner', status: 'Active', expirationDate: 'Mar 14, 2025', estate: 'The Beach - Unit 224', estateGroup: 'The Beach', estateGroupId: 1 },
  { id: 28, name: 'Wendy', lastName: 'Reed', email: 'wendy.reed@example.com', phone: '+1 (555) 000-1111', role: 'Resident', status: 'Active', expirationDate: 'Feb 28, 2025', estate: 'The Beach - Unit 225', estateGroup: 'The Beach', estateGroupId: 1 },
];

export const mockBusinessUsers = [
  {
    id: 1,
    name: 'Tech Solutions Inc',
    lastName: '',
    email: 'contact@techsolutions.com',
    role: 'Business Partner',
    status: 'Active',
    lastLogin: '2024-01-20',
    business: 'Tech Solutions Inc',
    phone: '+1 (555) 111-2222',
    expirationDate: 'Oct 26, 2024',
    category: 'Business',
    userType: 'Partner',
    channel: 'Direct',
  },
  {
    id: 2,
    name: 'Marketing Pro LLC',
    lastName: '',
    email: 'info@marketingpro.com',
    role: 'Vendor',
    status: 'Pending',
    lastLogin: 'Never',
    business: 'Marketing Pro LLC',
    phone: '+1 (555) 333-4444',
    expirationDate: 'Jun 30, 2024',
    category: 'Business',
    userType: 'Vendor',
    channel: 'Referral',
  },
  {
    id: 3,
    name: 'Security Systems Co',
    lastName: '',
    email: 'admin@securitysys.com',
    role: 'Service Provider',
    status: 'Active',
    lastLogin: '2024-01-19',
    business: 'Security Systems Co',
    phone: '+1 (555) 555-6666',
    expirationDate: 'Mar 15, 2025',
    category: 'Business',
    userType: 'Service',
    channel: 'Direct',
  },
  {
    id: 4,
    name: 'Cleaning Services Ltd',
    lastName: '',
    email: 'service@cleaningservices.com',
    role: 'Contractor',
    status: 'Active',
    lastLogin: '2024-01-18',
    business: 'Cleaning Services Ltd',
    phone: '+1 (555) 777-8888',
    expirationDate: 'Sep 30, 2024',
    category: 'Business',
    userType: 'Contractor',
    channel: 'Direct',
  },
];

export const mockRequests = [
  {
    id: 1,
    name: 'John',
    lastName: 'Doe',
    role: 'Owner',
    group: 'The Beach',
    property: 'Unit 101, The Beach',
    created: 'Jan 25, 2024',
    modified: 'Jan 25, 2024',
    sla: '2 days',
    status: 'Pending',
  },
  {
    id: 2,
    name: 'Jane',
    lastName: 'Smith',
    role: 'Resident',
    group: 'The Beach',
    property: 'Unit 102, The Beach',
    created: 'Jan 24, 2024',
    modified: 'Jan 24, 2024',
    sla: '1 day',
    status: 'Approved',
  },
  {
    id: 3,
    name: 'Mike',
    lastName: 'Johnson',
    role: 'Guest',
    group: 'The Beach',
    property: 'Unit 103, The Beach',
    created: 'Jan 23, 2024',
    modified: 'Jan 23, 2024',
    sla: '3 days',
    status: 'Rejected',
  },
  {
    id: 4,
    name: 'Sarah',
    lastName: 'Wilson',
    role: 'Owner',
    group: 'The Beach',
    property: 'Unit 104, The Beach',
    created: 'Jan 22, 2024',
    modified: 'Jan 22, 2024',
    sla: '2 days',
    status: 'Pending',
  },
  {
    id: 5,
    name: 'David',
    lastName: 'Brown',
    role: 'Resident',
    group: 'The Beach',
    property: 'Unit 105, The Beach',
    created: 'Jan 21, 2024',
    modified: 'Jan 21, 2024',
    sla: '1 day',
    status: 'Approved',
  },
  {
    id: 6,
    name: 'Lisa',
    lastName: 'Davis',
    role: 'Guest',
    group: 'The Beach',
    property: 'Unit 106, The Beach',
    created: 'Jan 20, 2024',
    modified: 'Jan 20, 2024',
    sla: '3 days',
    status: 'Rejected',
  },
  {
    id: 7,
    name: 'Robert',
    lastName: 'Miller',
    role: 'Owner',
    group: 'The Beach',
    property: 'Unit 107, The Beach',
    created: 'Jan 19, 2024',
    modified: 'Jan 19, 2024',
    sla: '2 days',
    status: 'Pending',
  },
  {
    id: 8,
    name: 'Emily',
    lastName: 'Garcia',
    role: 'Resident',
    group: 'The Beach',
    property: 'Unit 108, The Beach',
    created: 'Jan 18, 2024',
    modified: 'Jan 18, 2024',
    sla: '1 day',
    status: 'Approved',
  },
  {
    id: 9,
    name: 'James',
    lastName: 'Martinez',
    role: 'Guest',
    group: 'The Beach',
    property: 'Unit 109, The Beach',
    created: 'Jan 17, 2024',
    modified: 'Jan 17, 2024',
    sla: '3 days',
    status: 'Rejected',
  },
  {
    id: 10,
    name: 'Jennifer',
    lastName: 'Anderson',
    role: 'Owner',
    group: 'The Beach',
    property: 'Unit 110, The Beach',
    created: 'Jan 16, 2024',
    modified: 'Jan 16, 2024',
    sla: '2 days',
    status: 'Pending',
  },
  {
    id: 11,
    name: 'William',
    lastName: 'Taylor',
    role: 'Resident',
    group: 'The Beach',
    property: 'Unit 111, The Beach',
    created: 'Jan 15, 2024',
    modified: 'Jan 15, 2024',
    sla: '1 day',
    status: 'Approved',
  },
  {
    id: 12,
    name: 'Ashley',
    lastName: 'Thomas',
    role: 'Guest',
    group: 'The Beach',
    property: 'Unit 112, The Beach',
    created: 'Jan 14, 2024',
    modified: 'Jan 14, 2024',
    sla: '3 days',
    status: 'Rejected',
  },
  {
    id: 13,
    name: 'Christopher',
    lastName: 'Jackson',
    role: 'Owner',
    group: 'The Beach',
    property: 'Unit 113, The Beach',
    created: 'Jan 13, 2024',
    modified: 'Jan 13, 2024',
    sla: '2 days',
    status: 'Pending',
  },
  {
    id: 14,
    name: 'Amanda',
    lastName: 'White',
    role: 'Resident',
    group: 'The Beach',
    property: 'Unit 114, The Beach',
    created: 'Jan 12, 2024',
    modified: 'Jan 12, 2024',
    sla: '1 day',
    status: 'Approved',
  },
  {
    id: 15,
    name: 'Matthew',
    lastName: 'Harris',
    role: 'Guest',
    group: 'The Beach',
    property: 'Unit 115, The Beach',
    created: 'Jan 11, 2024',
    modified: 'Jan 11, 2024',
    sla: '3 days',
    status: 'Rejected',
  },
  {
    id: 16,
    name: 'Jessica',
    lastName: 'Martin',
    role: 'Owner',
    group: 'The Beach',
    property: 'Unit 116, The Beach',
    created: 'Jan 10, 2024',
    modified: 'Jan 10, 2024',
    sla: '2 days',
    status: 'Pending',
  },
  {
    id: 17,
    name: 'Daniel',
    lastName: 'Thompson',
    role: 'Resident',
    group: 'The Beach',
    property: 'Unit 117, The Beach',
    created: 'Jan 9, 2024',
    modified: 'Jan 9, 2024',
    sla: '1 day',
    status: 'Approved',
  },
  {
    id: 18,
    name: 'Michelle',
    lastName: 'Garcia',
    role: 'Guest',
    group: 'The Beach',
    property: 'Unit 118, The Beach',
    created: 'Jan 8, 2024',
    modified: 'Jan 8, 2024',
    sla: '3 days',
    status: 'Rejected',
  },
  {
    id: 19,
    name: 'Andrew',
    lastName: 'Martinez',
    role: 'Owner',
    group: 'The Beach',
    property: 'Unit 119, The Beach',
    created: 'Jan 7, 2024',
    modified: 'Jan 7, 2024',
    sla: '2 days',
    status: 'Pending',
  },
  {
    id: 20,
    name: 'Stephanie',
    lastName: 'Robinson',
    role: 'Resident',
    group: 'The Beach',
    property: 'Unit 120, The Beach',
    created: 'Jan 6, 2024',
    modified: 'Jan 6, 2024',
    sla: '1 day',
    status: 'Approved',
  },
  {
    id: 21,
    name: 'Joshua',
    lastName: 'Clark',
    role: 'Guest',
    group: 'The Beach',
    property: 'Unit 121, The Beach',
    created: 'Jan 5, 2024',
    modified: 'Jan 5, 2024',
    sla: '3 days',
    status: 'Rejected',
  },
  {
    id: 22,
    name: 'Nicole',
    lastName: 'Rodriguez',
    role: 'Owner',
    group: 'The Beach',
    property: 'Unit 122, The Beach',
    created: 'Jan 4, 2024',
    modified: 'Jan 4, 2024',
    sla: '2 days',
    status: 'Pending',
  },
  {
    id: 23,
    name: 'Kevin',
    lastName: 'Lewis',
    role: 'Resident',
    group: 'The Beach',
    property: 'Unit 123, The Beach',
    created: 'Jan 3, 2024',
    modified: 'Jan 3, 2024',
    sla: '1 day',
    status: 'Approved',
  },
  {
    id: 24,
    name: 'Kimberly',
    lastName: 'Lee',
    role: 'Guest',
    group: 'The Beach',
    property: 'Unit 124, The Beach',
    created: 'Jan 2, 2024',
    modified: 'Jan 2, 2024',
    sla: '3 days',
    status: 'Rejected',
  },
  {
    id: 25,
    name: 'Brian',
    lastName: 'Walker',
    role: 'Owner',
    group: 'The Beach',
    property: 'Unit 125, The Beach',
    created: 'Jan 1, 2024',
    modified: 'Jan 1, 2024',
    sla: '2 days',
    status: 'Pending',
  },
];



export const mockInvitations = [
  {
    id: 1,
    name: 'John',
    lastName: 'Doe',
    email: 'john.doe@example.com',
    phone: '+1 (555) 123-4567',
    role: 'Owner',
    status: 'Pending',
    invitationDate: 'Oct 26, 2023',
    expirationDate: 'Nov 26, 2023',
    estate: 'Unit 101, The Beach',
    estateGroup: 'The Beach',
    type: 'Guest',
    mainGuest: 'John Doe',
    destination: 'The Beach - Unit 101',
    dates: 'Oct 26 - Nov 26, 2023',
    host: 'Property Management',
  },
  {
    id: 2,
    name: 'Jane',
    lastName: 'Smith',
    email: 'jane.smith@example.com',
    phone: '+1 (555) 234-5678',
    role: 'Resident',
    status: 'Approved',
    invitationDate: 'Oct 25, 2023',
    expirationDate: 'Nov 25, 2023',
    estate: 'Unit 102, The Beach',
    estateGroup: 'The Beach',
    type: 'Supplier',
    mainGuest: 'Jane Smith',
    destination: 'The Beach - Unit 102',
    dates: 'Oct 25 - Nov 25, 2023',
    host: 'Property Management',
  },
  {
    id: 3,
    name: 'Mike',
    lastName: 'Johnson',
    email: 'mike.johnson@example.com',
    phone: '+1 (555) 345-6789',
    role: 'Guest',
    status: 'Expired',
    invitationDate: 'Oct 24, 2023',
    expirationDate: 'Oct 31, 2023',
    estate: 'Unit 103, The Beach',
    estateGroup: 'The Beach',
    type: 'Employee',
    mainGuest: 'Mike Johnson',
    destination: 'The Beach - Unit 103',
    dates: 'Oct 24 - Oct 31, 2023',
    host: 'Property Management',
  }
];

export const mockDrawerRequests = [
  {
    id: 1,
    title: 'Property Access Request',
    requester: 'John Doe',
    property: 'Unit 101, The Beach',
    date: 'Oct 26, 2023',
    status: 'Pending',
    type: '🏠',
    requesterRole: 'Owner',
    modificationDate: 'Oct 26, 2023',
    role: 'Owner',
    estateGroup: 'The Beach',
    estate: 'Unit 101, The Beach',
    dateRequested: 'Oct 26, 2023',
    sla: '2 days',
  },
  {
    id: 2,
    title: 'Amenity Booking Request',
    requester: 'Bob Williams',
    property: 'Tennis Court (10 AM - 11 AM)',
    date: 'Oct 25, 2023',
    status: 'Approved',
    type: '🎾',
    requesterRole: 'Resident',
    modificationDate: 'Oct 25, 2023',
    role: 'Resident',
    estateGroup: 'The Beach',
    estate: 'Tennis Court (10 AM - 11 AM)',
    dateRequested: 'Oct 25, 2023',
    sla: '1 day',
  },
  {
    id: 3,
    title: 'Maintenance Request',
    requester: 'Alice Johnson',
    property: 'Unit 205, The Beach',
    date: 'Oct 24, 2023',
    status: 'Processing',
    type: '🔧',
    requesterRole: 'Owner',
    modificationDate: 'Oct 24, 2023',
    role: 'Owner',
    estateGroup: 'The Beach',
    estate: 'Unit 205, The Beach',
    dateRequested: 'Oct 24, 2023',
    sla: '3 days',
  }
];

export const mockDrawerSupportTickets = [
  {
    id: 1,
    title: 'Elevator Maintenance Issue',
    description: 'Elevator is making strange noises and stopping between floors',
    priority: 'High',
    status: 'Open',
    category: 'Maintenance',
    createdDate: 'Oct 26, 2023',
    updatedDate: 'Oct 26, 2023',
    assignedTo: 'Maintenance Team',
    requester: 'John Doe',
    unit: 'Unit 101',
    ticket: 'SUP-001',
    creationDate: 'Oct 26, 2023',
  },
  {
    id: 2,
    title: 'Internet Connectivity Problem',
    description: 'WiFi is not working in the common areas',
    priority: 'Medium',
    status: 'Processing',
    category: 'IT Support',
    createdDate: 'Oct 25, 2023',
    updatedDate: 'Oct 26, 2023',
    assignedTo: 'IT Support',
    requester: 'Jane Smith',
    unit: 'Unit 102',
    ticket: 'SUP-002',
    creationDate: 'Oct 25, 2023',
  },
  {
    id: 3,
    title: 'Parking Space Dispute',
    description: 'Someone is parking in my assigned space',
    priority: 'Low',
    status: 'Resolved',
    category: 'Administrative',
    createdDate: 'Oct 24, 2023',
    updatedDate: 'Oct 25, 2023',
    assignedTo: 'Property Manager',
    requester: 'Mike Johnson',
    unit: 'Unit 103',
    ticket: 'SUP-003',
    creationDate: 'Oct 24, 2023',
  }
];
